import _ from "lodash";
import { callNativeMethodAsync } from "./base";
import { NAVIGATION_BAR_MODE } from "./constant";
import {
  isLama,
  isWyak,
  isMisu,
  isDevEnv,
  isLamaLudo,
  isWeParty,
  isInChat,
} from "@mono/utils";
import { isIOS } from "@mono/utils";

function xlogE(tag, msg) {
  log({ tag, msg, xlog: true });
}

/**
 * 关闭当前页面
 */
export function closeWindow() {
  callNativeMethodAsync("closeWindow", null, null).catch((error) => {
    xlogE("tag_bridge_call", `closeWindow, error:${error}`);
  });
}

let deviceInfo;

/**
 * 获取设备信息
 * @returns { os: "android", osVersion: "8.0", apiLevel: 26, screenWidth: 750, screenHeight: 1080, versionCode: 24, versionName: "1.0.23", appChannel: "gp" }
 */
export async function getDeviceInfo() {
  if (deviceInfo) {
    return deviceInfo;
  }

  try {
    deviceInfo = await callNativeMethodAsync("getDeviceInfo", null);
  } catch (error) {
    xlogE("tag_bridge_call", `getDeviceInfo, error:${error}`);
  }
  return deviceInfo;
}

/**
 * 获取版本号
 * @returns 24
 */
export async function getVersionCode() {
  const deviceInfo = await getDeviceInfo();
  return deviceInfo ? deviceInfo.versionCode : 0;
}

/**
 * 获取应用渠道
 * @returns gp
 */
export async function getAppChannel() {
  const deviceInfo = await getDeviceInfo();
  return deviceInfo ? deviceInfo.appChannel : "gp";
}

/**
 * 获取平台
 * @returns
 */
export async function getAppPlatform() {
  const appChannel = await getAppChannel();
  let platform = "google";
  if (appChannel === "apple_store") {
    platform = "ios";
  } else if (appChannel === "huawei") {
    platform = "huawei";
  }
  return platform;
}

/**
 * 获取App名称
 */
export function getAppName() {
  if (isLama) {
    return "Lama";
  } else if (isWyak) {
    return "Wyak";
  } else if (isMisu) {
    return "MisU";
  } else if (isLamaLudo) {
    return "Lama Ludo";
  } else if (isWeParty) {
    return "WeParty";
  } else if (isInChat) {
    return "InChat";
  } else {
    return "";
  }
}

/**
 * 获取App前缀
 */
export function getAppPrefix() {
  if (isLama) {
    return "lama";
  } else if (isWyak) {
    return "wyak";
  } else if (isMisu) {
    return "misU";
  } else if (isLamaLudo) {
    return "lama_ludo";
  } else if (isWeParty) {
    return "we_party";
  } else {
    return "";
  }
}

/**
 * 获取App联系邮箱
 */
export function getAppContactEmail() {
  if (isLama) {
    return "wenext.lama@gmail.com";
  } else if (isWyak) {
    return "wyakwenext.@gmail.com";
  } else if (isMisu) {
    return "";
  } else if (isLamaLudo) {
    return "ludo.courage@gmail.com";
  } else if (isWeParty) {
    return "partyjoy.business@gmail.com";
  } else if (isInChat) {
    return "inchat.business@gmail.com";
  } else {
    return "";
  }
}

/**
 * 获取Deeplink Scheme和Host
 */
export function getSchemeHost() {
  if (isLama) {
    return "wenext://lama";
  } else if (isWyak) {
    return "wenext://wayak";
  } else if (isMisu) {
    return "sublive://misu";
  } else if (isLamaLudo) {
    return "courage://ludo";
  } else if (isWeParty) {
    return "partyjoy://weparty";
  } else if (isInChat) {
    return "partychat://inchat";
  } else {
    return "";
  }
}

/**
 * 获取状态栏高度(单位: 像素)
 * @returns { height: 44 }
 */
export async function getStatusBarHeight() {
  var statusBarHeight = 0;
  try {
    let statusBar = await callNativeMethodAsync("getStatusBarHeight", null);
    statusBarHeight = statusBar.height;
  } catch (error) {
    xlogE("tag_bridge_call", `getStatusBarHeight, error:${error}`);
  }
  return statusBarHeight;
}
let token;

/**
 * 获取Token
 * @returns {token: ""}
 */
export async function getToken() {
  if (token) {
    return token;
  }

  try {
    let res = await callNativeMethodAsync("getToken", null, 5000);
    token = res.token;
  } catch (error) {
    xlogE("tag_bridge_call", `getToken, error:${error}`);
  }
  return token;
}

/**
 * 跳转充值
 */
export function goRecharge() {
  callNativeMethodAsync("goRecharge", null, null).catch((error) => {
    xlogE("tag_bridge_call", `goRecharge, error:${error}`);
  });
}

/**
 * 余额不足弹窗
 */
export function showRechargeTip(data) {
  callNativeMethodAsync("showRechargeTip", data, null).catch((error) => {
    xlogE("tag_bridge_call", `showRechargeTip, error:${error}`);
  });
}

/**
 * 获取locale信息
 * @returns {language_code: "en", "country_code":"EN" }
 */
export async function getLocaleInfo() {
  let res;
  try {
    res = callNativeMethodAsync("getLocaleInfo", null);
  } catch (error) {
    xlogE("tag_bridge_call", `getLocaleInfo, error:${error}`);
  }
  return res;
}

/**
 * 切换谷歌支付渠道
 */
export function switchGoogleChannel() {
  callNativeMethodAsync("switchGoogleChannel", null, null).catch((error) => {
    xlogE("tag_bridge_call", `switchGoogleChannel, error:${error}`);
  });
}

/**
 * 打开全屏web页
 * @param data { url: "" }
 */
export function openFullPageWebView(data) {
  callNativeMethodAsync("openFullPageWebView", data, null).catch((error) => {
    xlogE("tag_bridge_call", `openFullPageWebView, error:${error}`);
  });
}

/**
 * 打开反馈页
 *  @param data type
 */
export function goFeedback(data) {
  callNativeMethodAsync("goFeedback", data, null).catch((error) => {
    xlogE("tag_bridge_call", `goFeedback, error:${error}`);
  });
}

/**
 * 通用method
 *  @param data {method: "", minVersionCode: 0, params:{}}
 */
export async function callCommonMethod(data) {
  let res;
  try {
    res = await callNativeMethodAsync("commonMethod", data);
  } catch (error) {
    xlogE("tag_bridge_call", `callCommonMethod, error:${error}`);
  }
  return res;
}

/**
 * 判断该deeplink是否可用
 *  @param data {path: ""}
 *  @returns {isSupport: false}
 */
export async function isDeeplinkSupport(data) {
  let res;
  try {
    res = await callNativeMethodAsync("isDeeplinkSupport", data);
  } catch (error) {
    xlogE("tag_bridge_call", `isDeeplinkSupport, error:${error}`);
  }
  return res;
}

/**
 * 分发deeplink
 *  @param data {deeplink:"", path:""}
 */
export async function dispatchDeeplink(data) {
  const support = await isDeeplinkSupport({ path: data.path });
  if (support && support.isSupport) {
    window.location.href = data.deeplink;
  }
}

/**
 * 跳转到个人资料页
 * @param uid 用户uid
 * @returns
 */
export function goUserProfle(uid) {
  if (_.isNil(uid)) {
    return;
  }
  dispatchDeeplink({
    deeplink: `${getSchemeHost()}/userProfile?extra_uid=${uid}`,
    path: "/userProfile",
  });
}

/**
 * 跳转到房间页
 * @param roomId 房间id
 * @returns
 */
export function goRoom(roomId) {
  if (_.isNil(roomId)) {
    return;
  }
  dispatchDeeplink({
    deeplink: `${getSchemeHost()}/room?room_id=${roomId}`,
    path: "/room",
  });
}

/**
 * 跳转到家族页
 * @param familyId 家族id（可不传）
 * @returns
 */
export function goFamily(familyId) {
  if (isLama && isIOS) {
    return;
  }
  let link = "";
  if (isMisu) {
    link = `https://h5-family${isDevEnv ? "-test" : ""}.appmisu.com/`;
  } else {
    link = `${getSchemeHost()}/family/home`;
  }

  if (_.isNil(familyId)) {
    if (isMisu) {
      openFullPageWebView({ url: `${link}index?entry=native` });
      return;
    }
  } else {
    if (isMisu) {
      openFullPageWebView({
        url: `${link}details?entry=native&id=${familyId}`,
      });
      return;
    }
    link = `${link}?family_id=${familyId}`;
  }

  dispatchDeeplink({
    deeplink: link,
    path: "/family/home",
  });
}

/**
 * 获取选中的国家
 */
export async function getSelectedCountry() {
  callNativeMethodAsync("getSelectedCountry", null, null).catch((error) => {
    xlogE("tag_bridge_call", `getSelectedCountry, error:${error}`);
  });
}

/**
 * log
 * @param { tag: "", msg: "", xlog: False}
 */
export function log(data) {
  callNativeMethodAsync("log", data).catch((error) => {
    console.log("log, error:", error);
  });
}

/**
 * 设置全屏web页为沉浸式
 */
export function setImmersionMode() {
  callNativeMethodAsync("setImmersionMode", null, null).catch((error) => {
    xlogE("tag_bridge_call", `setImmersionMode, error:${error}`);
  });
}

/**
 * 隐藏Native导航栏
 */
export function hideNavigationBar() {
  callNativeMethodAsync("hideNavigationBar", null, null).catch((error) => {
    xlogE("tag_bridge_call", `hideNavigationBar, error:${error}`);
  });
}

export function setNavigationBarDarkMode() {
  setNavigationBarMode(NAVIGATION_BAR_MODE.DARK);
}

export function setNavigationBarLightMode() {
  setNavigationBarMode(NAVIGATION_BAR_MODE.LIGHT);
}

/**
 * 设置导航栏
 * @param {*} mode
 */
function setNavigationBarMode(mode) {
  callNativeMethodAsync("setNavigationBarMode", { mode }, null).catch(
    (error) => {
      xlogE("tag_bridge_call", `setNavigationBarMode, error:${error}`);
    }
  );
}

/**
 * 获取个人用户信息
 *  @returns {"birthday":0,"country":"","flag":"","gender":1,"isNew":false,"level":1,"name":"good","photoWall":"","profile":"","role":0,"sid":100001003,"uid":7008,"url":""}
 */
export async function getMyUserInfo() {
  let res;
  try {
    res = await callNativeMethodAsync("getMyUserInfo", null, 500, true);
  } catch (error) {
    xlogE("tag_bridge_call", `getMyUserInfo, error:${error}`);
  }
  return res;
}

/**
 * 获取个人用户信息，使用时注意不是所有应用都有实现，主要用于Lama Ludo
 * @param data: {cache: true, attrs:[1,2]}
 * @returns {"birthday":0,"country":"","flag":"","gender":1,"isNew":false,"level":1,"name":"good","photoWall":"","profile":"","role":0,"sid":100001003,"uid":7008,"url":""}
 */
export async function getMyUserInfoNew(data) {
  let res;
  try {
    res = await callNativeMethodAsync("getMyUserInfoNew", data, 500, true);
  } catch (error) {
    xlogE("tag_bridge_call", `getMyUserInfoNew, error:${error}`);
  }
  return res;
}

/**
 * 获取自己的uid
 * @returns uid
 */
export async function getMyUid() {
  const userInfo = await getMyUserInfo();
  if (_.isNil(userInfo)) {
    return 0;
  }

  return userInfo.uid;
}

/**
 * 获取自己的sid
 * @returns sid
 */
export async function getMySid() {
  const userInfo = await getMyUserInfo();
  if (_.isNil(userInfo)) {
    return 0;
  }

  return userInfo.sid;
}

/**
 * 获取自己的等级
 * @returns level
 */
export async function getMyLevel() {
  const userInfo = await getMyUserInfo();
  if (_.isNil(userInfo)) {
    return 0;
  }

  return userInfo.level;
}

/**
 * 获取自己的大区
 * @returns region
 */
export async function getMyRegion() {
  const userInfo = await getMyUserInfo();
  if (_.isNil(userInfo)) {
    return 0;
  }

  return userInfo.region;
}

/**
 * 自己是否是币商
 * @returns true: 是，false: 不是
 */
export async function isCurrencySeller() {
  const userInfo = await getMyUserInfo();
  if (_.isNil(userInfo)) {
    return false;
  }

  return userInfo.currencySeller === true;
}

/**
 * 邀请返利分享弹窗
 *  @param data {invitationCode: ""}
 */
export function userRebateInviteNow(data) {
  callNativeMethodAsync("userRebateInviteNow", data, null).catch((error) => {
    xlogE("tag_bridge_call", `userRebateInviteNow, error:${error}`);
  });
}

/**
 * 拉新分享好友发IM消息弹窗 inchat
 * @param data {type: 1} 1成员团队 2团长团队
 */
export async function showShareToFriendsDialog(data) {
  callNativeMethodAsync("showShareToFriendsDialog", data, null).catch(
    (error) => {
      xlogE("tag_bridge_call", `showShareToFriendsDialog, error:${error}`);
    }
  );
}

/**
 * 检查是否显示拉新团队邀请引导页 inchat
 * @return data {hasShowTeamInviteGuide: true} 1成员团队 2团长团队
 */
export async function checkShowTeamInviteGuide() {
  let res;
  try {
    res = await callNativeMethodAsync(
      "checkShowTeamInviteGuide",
      null,
      500,
      true
    );
  } catch (error) {
    xlogE("tag_bridge_call", `checkShowTeamInviteGuide, error:${error}`);
  }
  return res;
}

/**
 * 更新是否显示拉新团队邀请引导页 inchat
 *
 * @param data {"hasShowTeamInviteGuide":true}
 */
export async function updateShowTeamInviteGuide(data) {
  callNativeMethodAsync("updateShowTeamInviteGuide", data, null).catch(
    (error) => {
      xlogE("tag_bridge_call", `updateShowTeamInviteGuide, error:${error}`);
    }
  );
}

/**
 * 发起谷歌支付（下单完成后）launchGooglePay
 *  @param data {productId: 0, skuId: "", orderId: "", productType: ""}
 */
export async function launchGooglePay(data) {
  let res;
  try {
    res = await callNativeMethodAsync("launchGooglePay", data, null);
  } catch (error) {
    xlogE("tag_bridge_call", `launchGooglePay, error:${error}`);
  }
  return res;
}

/**
 * 高价值用户进房震动是否开启
 *  @returns {open: true}
 */
export async function isHighPotentialVibrationOpen() {
  let res;
  try {
    res = await callNativeMethodAsync(
      "isHighPotentialVibrationOpen",
      null,
      null
    );
  } catch (error) {
    xlogE("tag_bridge_call", `isHighPotentialVibrationOpen, error:${error}`);
  }
  return res;
}

/**
 * 切换高价值用户进房震动开关
 *  @param data {open: true}
 *  @returns {open: true}
 */
export async function switchHighPotentialVibration(data) {
  let res;
  try {
    res = await callNativeMethodAsync(
      "switchHighPotentialVibration",
      data,
      null
    );
  } catch (error) {
    xlogE("tag_bridge_call", `switchHighPotentialVibration, error:${error}`);
  }
  return res;
}

/**
 * 搜索用户
 * @param data {"scene":1,"tip":"tip"}
 * @returns {"uidList":[1001]}
 */
export async function searchUsers(data) {
  let res;
  try {
    res = await callNativeMethodAsync("searchUsers", data, null);
  } catch (error) {
    xlogE("tag_bridge_call", `searchUsers, error:${error}`);
  }
  return res;
}

/**
 * 保存数据到Excel
 * @param data {fileName: "salary.xls", sheetName: "SheetName", data: [{type: 0, data: ["data1", "data2"]}]}
 * @returns {"result":1, "filePath":""}
 */
export async function saveToExcel(data) {
  let res;
  try {
    res = await callNativeMethodAsync("saveToExcel", data, null);
  } catch (error) {
    xlogE("tag_bridge_call", `saveToExcel, error:${error}`);
  }
  return res;
}

/**
 * 发送邮件
 * @param data {senderEmail:"senderEmail", senderPassword:"", subject: "subject", description: "mail description", filePath: ""}
 */
export async function sendEmail(data) {
  let res;
  try {
    res = await callNativeMethodAsync("sendEmail", data, null);
  } catch (error) {
    xlogE("tag_bridge_call", `sendEmail, error:${error}`);
  }
  return res;
}

/**
 * 获取应用系统
 * @returns android/ios
 */
export async function getOs() {
  const deviceInfo = await getDeviceInfo();
  return deviceInfo ? deviceInfo.os : "";
}

/**
 * 是否是iOS系统
 */
export async function iOS() {
  const os = await getOs();
  return os && os == "ios";
}

/**
 * 是否是Android系统
 */
export async function android() {
  const os = await getOs();
  return os && os == "android";
}

/**
 * 发起苹果支付（下单完成后）launchApplePay
 *  @param data {productId: 0, skuId: "", orderId: ""}
 */
export async function launchApplePay(data) {
  let res;
  try {
    res = await callNativeMethodAsync("launchApplePay", data, null);
  } catch (error) {
    xlogE("tag_bridge_call", `launchApplePay, error:${error}`);
  }
  return res;
}

/**
 * 获取当前所在房间ID
 * @returns roomId
 */
export async function getJoinedRoomId() {
  let res;
  try {
    res = await callNativeMethodAsync("getJoinedRoomId", null, null);
  } catch (error) {
    xlogE("tag_bridge_call", `getJoinedRoomId, error:${error}`);
  }
  return res ? res.roomId : 0;
}

/**
 * 上传文件
 * @param data {urls:[]}
 */
export async function uploadFile(data) {
  let res;
  try {
    res = await callNativeMethodAsync("uploadFile", data, null);
  } catch (error) {
    xlogE("tag_bridge_call", `uploadFile, error:${error}`);
  }
  return res;
}

/**
 * 上报web统计
 * @param data {event_id: "", events: {}}
 */
export function stat(data) {
  callNativeMethodAsync("stat", data, null).catch((error) => {
    xlogE("tag_bridge_call", `stat, error:${error}`);
  });
}

/**
 * 用户是否在麦上
 *  @param data {uidSet: []}
 */
export async function isUserOnMic(data) {
  let res;
  try {
    res = await callNativeMethodAsync("isUserOnMic", data, null);
  } catch (error) {
    xlogE("tag_bridge_call", `isUserOnMic, error:${error}`);
  }
  return res;
}

/**
 * 上报af事件
 * @param data {event_name: "test", params: {p1: ""}}
 */
export function reportAfBackEvent(data) {
  callNativeMethodAsync("reportAfBackEvent", data, null).catch((error) => {
    xlogE("tag_bridge_call", `reportAfBackEvent, error:${error}`);
  });
}

/**
 * 去分享
 * @param data {shareImageUrl: "", shareText: "", deeplink: "", source: "", shareSuffixText: ""}
 */
export function goShare(data) {
  callNativeMethodAsync("goShare", data, null).catch((error) => {
    xlogE("tag_bridge_call", `goShare, error:${error}`);
  });
}

export const getLanguageCode = async () => {
  try {
    const localeInfo = await getLocaleInfo();
    if (localeInfo) {
      return localeInfo.language_code;
    }
  } catch (e) {
    // console.log("getLanguageCode, e:", e);
  }
  return "en";
};

export const getCountryCode = async () => {
  const localeInfo = await getLocaleInfo();
  if (localeInfo) {
    return localeInfo.country_code;
  } else {
    return "EN";
  }
};

/**
 * 通过手机默认浏览器打开web页
 * @param data { url: "" }
 */
export function openInPhoneBrowser(data) {
  callNativeMethodAsync("openInPhoneBrowser", data, null).catch((error) => {
    xlogE("tag_bridge_call", `openInPhoneBrowser, error:${error}`);
  });
}

/**
 * 获取包名
 * @returns ""
 */
export async function getPackageName() {
  const deviceInfo = await getDeviceInfo();
  return deviceInfo ? deviceInfo.packageName : "";
}

/**
 * 分享链接
 * @param data {
 *    "channel": "facebook/whatsapp/system",
 *    "source":"",
 *    "deeplink":"",
 *    "link":"",
 *    "title":"",
 *    "desc":"",
 *    "img":"",
 *    "minVersion":1
 * }
 *
 * @returns {"shareLink":""}
 */
export async function shareLink(data) {
  let link;
  try {
    link = await callNativeMethodAsync("shareLink", data, null);
  } catch (error) {
    xlogE("tag_bridge_call", `shareLink, error:${error}`);
  }
  return link;
}

/**
 * 获取分享短链链接
 * @param data {
 *    "source":"",
 *    "deeplink":"",
 *    "link":"",
 *    "title":"",
 *    "desc":"",
 *    "img":"",
 *    "minVersion":1
 * }
 *
 * @returns {"shareLink":""}
 */
export async function getShareLink(data) {
  let shareLink;
  try {
    shareLink = await callNativeMethodAsync("getShareLink", data, null);
  } catch (error) {
    xlogE("tag_bridge_call", `getShareLink, error:${error}`);
  }
  return shareLink;
}

/**
 * 复制到粘贴板
 * @param data {"content": ""}
 */
export async function copyToClipBoard(data) {
  callNativeMethodAsync("copyToClipBoard", data, null).catch((error) => {
    xlogE("tag_bridge_call", `copyToClipBoard, error:${error}`);
  });
}

/**
 * 获取本地的分享奖励链接
 * @param data {
 * "channel": channel
 * }
 *
 * @returns {"link":""}
 */
export async function getInviteRewardShareLink(data) {
  let link;
  try {
    link = await callNativeMethodAsync("getInviteRewardShareLink", data, null);
  } catch (error) {
    xlogE("tag_bridge_call", `getInviteRewardShareLink, error:${error}`);
  }
  return link;
}

/**
 * 更新本地的分享奖励链接
 *
 * @param data {"link":""}
 */
export async function updateInviteRewardShareLink(data) {
  callNativeMethodAsync("updateInviteRewardShareLink", data, null).catch(
    (error) => {
      xlogE("tag_bridge_call", `updateInviteRewardShareLink, error:${error}`);
    }
  );
}

/**
 *
 * @param {*音效名} soundName
 * @param {*音效类型} soundType
 * @param {*循环次数} loop
 */
export function playSound(soundName, soundType = 0, loop = 0) {
  callNativeMethodAsync(
    "playSound",
    { soundName, soundType, loop },
    null
  ).catch((error) => {
    xlogE("tag_bridge_call", `playSound, error:${error}`);
  });
}

/**
 * 停止播放音效
 * @param {*音效名} soundName 例如coin.mp3
 */
export function stopSound(soundName) {
  callNativeMethodAsync("stopSound", { soundName }, null).catch((error) => {
    xlogE("tag_bridge_call", `stopSound, error:${error}`);
  });
}

/**
 * 获取用户大区
 * @returns 用户大区
 */
export async function getUserRegion() {
  const userInfo = await getMyUserInfo();
  if (_.isNil(userInfo)) {
    return "";
  }

  return userInfo.region;
}

/**
 * 获取用户国家
 * @returns 用户国家码
 */
export async function getUserCountry() {
  const userInfo = await getMyUserInfo();
  if (_.isNil(userInfo)) {
    return "";
  }

  return userInfo.country;
}

/**
 * @param {*游戏类型} type
 */
export function openNativeGame(type) {
  callNativeMethodAsync(
    "openNativeGame",
    { type },
    null
  ).catch((error) => {
    xlogE("tag_bridge_call", `openNativeGame, error:${error}`);
  });
}


const COUNTRY_CODE_TO_AREA_CODE = {
  MA: 212,
  PK: 92,
  EG: 20,
  BH: 973,
  KW: 965,
  OM: 968,
  QA: 974,
  SA: 966,
  AE: 971,
  UA: 380,
  VU: 678,
  EC: 593,
  VN: 84,
  DZ: 213,
  VG: 1,
  DM: 1,
  VE: 58,
  DO: 1,
  VC: 1,
  VA: 379,
  DE: 49,
  UZ: 998,
  UY: 598,
  DK: 45,
  DJ: 253,
  UG: 256,
  ET: 251,
  ES: 34,
  ER: 291,
  EH: 212,
  EE: 372,
  TZ: 255,
  TT: 1,
  TW: 886,
  TV: 688,
  GD: 1,
  GE: 995,
  GF: 594,
  GA: 241,
  GB: 44,
  FR: 33,
  FO: 298,
  FK: 500,
  FJ: 679,
  FM: 691,
  FI: 358,
  WS: 685,
  GY: 592,
  GW: 245,
  GT: 502,
  GR: 30,
  GQ: 240,
  GP: 590,
  WF: 681,
  GN: 224,
  GM: 220,
  GL: 299,
  GI: 350,
  GH: 233,
  GG: 44,
  RE: 262,
  RO: 40,
  AT: 43,
  AR: 54,
  AX: 358,
  AW: 297,
  AU: 61,
  AZ: 994,
  BA: 387,
  AC: 247,
  PT: 351,
  AD: 376,
  PW: 680,
  AG: 1,
  AF: 93,
  PS: 970,
  AL: 355,
  AI: 1,
  AO: 244,
  PY: 595,
  AM: 374,
  BW: 267,
  TG: 228,
  BY: 375,
  TD: 235,
  BS: 1,
  TK: 690,
  BR: 55,
  TJ: 992,
  BT: 975,
  TH: 66,
  TO: 676,
  TN: 216,
  TM: 993,
  CA: 1,
  TL: 670,
  BZ: 501,
  TR: 90,
  BF: 226,
  BG: 359,
  SV: 503,
  BI: 257,
  ST: 239,
  BB: 1,
  SY: 963,
  SZ: 268,
  BD: 880,
  BE: 32,
  BN: 673,
  BO: 591,
  BJ: 229,
  TC: 1,
  BM: 1,
  CZ: 420,
  SD: 249,
  CY: 357,
  SC: 248,
  CX: 61,
  SE: 46,
  CV: 238,
  SH: 290,
  CU: 53,
  SG: 65,
  SJ: 47,
  SI: 386,
  SL: 232,
  SK: 421,
  SN: 221,
  SM: 378,
  SO: 252,
  SR: 597,
  CI: 225,
  RS: 381,
  CG: 242,
  CH: 41,
  RU: 7,
  CF: 236,
  RW: 250,
  CC: 61,
  CD: 243,
  CR: 506,
  CO: 57,
  CM: 237,
  CN: 86,
  CK: 682,
  CL: 56,
  SB: 677,
  LV: 371,
  LU: 352,
  LT: 370,
  LY: 218,
  LS: 266,
  LR: 231,
  MG: 261,
  MH: 692,
  ME: 382,
  MF: 590,
  MK: 389,
  ML: 223,
  MC: 377,
  MD: 373,
  MV: 960,
  MU: 230,
  MX: 52,
  MW: 265,
  MZ: 258,
  MY: 60,
  MN: 976,
  MM: 95,
  MO: 853,
  MR: 222,
  MQ: 596,
  MT: 356,
  MS: 1,
  NF: 672,
  NG: 234,
  NI: 505,
  NL: 31,
  NA: 264,
  NC: 687,
  NE: 227,
  NZ: 64,
  NU: 683,
  NR: 674,
  NP: 977,
  NO: 47,
  PL: 48,
  PM: 508,
  PH: 63,
  PE: 51,
  PF: 689,
  PG: 675,
  PA: 507,
  HK: 852,
  ZA: 27,
  HN: 504,
  HR: 385,
  HT: 509,
  HU: 36,
  ZM: 260,
  ID: 62,
  ZW: 263,
  IE: 353,
  IL: 972,
  IM: 44,
  IN: 91,
  IO: 246,
  IQ: 964,
  IR: 98,
  YE: 967,
  IS: 354,
  IT: 39,
  JE: 44,
  YT: 262,
  JP: 81,
  JO: 962,
  JM: 1,
  KI: 686,
  KH: 855,
  KG: 996,
  KE: 254,
  KP: 850,
  KR: 82,
  KM: 269,
  KN: 1,
  KY: 1,
  KZ: 7,
  LA: 856,
  LC: 1,
  LB: 961,
  LI: 423,
  LK: 94,
  BQ: 599,
  CW: 599,
  BL: 590,
  SX: 1,
  SS: 211,
};

export const getCountryAreaCode = (countryCode) => {
  return COUNTRY_CODE_TO_AREA_CODE[countryCode];
};
